var myApp = null;

(function (angular, $) {
    'use strict';
    myApp = angular.module('digitickApp', [
        // 'oc.lazyLoad',
        'ui.bootstrap',
        'ngCookies',
        'ngAnimate',
        'siyfion.sfTypeahead',
        'perfect_scrollbar',
        'ngFitText',
        // 'angularLazyImg',
        'boxuk.translation',
        'ngSanitize'
    ]);

    myApp.config(['fitTextConfigProvider', function(fitTextConfigProvider) {
        fitTextConfigProvider.config = {
        };
    }]);
}(angular, jQuery));

//---------------------------------------------
// DIRECTIVES
//---------------------------------------------

(function (angular, $) {
    'use strict';
    angular.module('digitickApp').directive('deferredCloak', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                attrs.$set('deferredCloak', undefined);
                element.removeClass('deferred-cloak');
            }
        };
    });
}(angular, jQuery));

(function (angular, $) {
    'use strict';
    angular.module('digitickApp').directive('deferredRemove', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.remove();
            }
        };
    });
}(angular, jQuery));

(function (angular, $) {
    'use strict';
    angular.module('digitickApp').directive('sessionName', ['$rootScope', function ($rootScope) {
        return {
            restrict: 'A',
            compile: function (element, attrs) {
                $rootScope.sessionName = attrs.sessionName;
            }
        };
    }]);
}(angular, jQuery));

(function (angular, $) {
    'use strict';
    angular.module('digitickApp').directive('myTransclude', function () {
        return {
            compile: function (tElement, tAttrs, transclude) {
                return function (scope, iElement, iAttrs) {
                    transclude(scope.$new(), function (clone) {
                        iElement.append(clone);
                    });
                };
            }
        };
    });
}(angular, jQuery));

(function (angular, $) {
    'use strict';
    angular.module('digitickApp').directive('ancreScrollTo', ['$rootScope', '$q', '$document', '$window', function ($rootScope, $q, $document, $window) {
        return {
            restrict: 'E',
            replace: true,

            template: '<div ng-click="scrollToNext($event)" class="scroll_link" ng-show="showLink"><span class="fa-stack fa-lg"><i class="fa fa-circle-o fa-stack-2x"></i><i class="fa fa-angle-down fa-stack-1x"></i></span></div>',
            link: function (scope, element, attrs) {
                scope.selector = '.scroll-ancre';
                scope.showLink = true;
                scope.delta = 0;

                $rootScope.$watch('headerTinyHeight', function () {
                    scope.delta = $rootScope.headerTinyHeight;
                });

                scope.scrollToNext = function ($event) {
                    $event.preventDefault();
                    $event.stopPropagation();

                    var next = scope.getNext().then(function (el) {
                        if (typeof $rootScope.headerTinyHeight != 'undefined') {
                            el.scrollTo(-scope.delta);
                        } else {
                            el.scrollTo();
                        }
                    }, function (msg) {
                    });
                };

                scope.getNext = function () {
                    var deferred = $q.defer();
                    var els = angular.element(scope.selector);
                    angular.forEach(els, function (el) {
                        var elObj = angular.element(el);
                        if ($document.scrollTop() < elObj.offset().top - scope.delta) {
                            deferred.resolve(elObj);
                        }
                    });
                    deferred.reject('');
                    return deferred.promise;
                };

                angular.element($window).bind('scroll', function () {
                    if (
                        this.pageYOffset + this.innerHeight < $document.height() - scope.delta
                        && angular.element(scope.selector).length > 0
                        && $document.scrollTop() < angular.element(scope.selector).last().offset().top - scope.delta) {
                        scope.showLink = true;
                    }
                    else {
                        scope.showLink = false;
                    }
                }).triggerHandler('scroll');
            }
        };
    }]);
}(angular, jQuery));

(function (angular, $) {
    'use strict';
    angular.module('digitickApp').directive('digitickAffiche', ['$window', '$timeout', '$sce', function ($window, $timeout, $sce) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                affiche: '='
            },
            templateUrl: $sce.trustAsResourceUrl(getAsset('bundles/digitickcms/views/digitickAffiche.html')),
            link: function (scope, element, attrs) {
                var STATE_ONLINE = 1;
                var STATE_OFFLINE = 2;
                var STATE_CANCEL_REFUND = 3;
                var STATE_CANCEL_NO_REFUND = 4;
                var STATE_DEFER_REFUND = 5;
                var STATE_DEFER_NO_REFUND = 6;
                var STATE_CANCEL = 7;
                var STATE_COMPLETE = 8;
                var STATE_SOON = 9;
                var STATE_END = 10;
                var STATE_AVAILABLE = 11;

                //-------------------------------------------------------
                //
                //-------------------------------------------------------

                function preTraitementImage() {
                    if (scope.affiche.image.lazy == true) {
                        if (scope.affiche.image.url == '' && angular.isDefined(scope.affiche.image.urlDefault)) {
                            scope.affiche.image.url = scope.affiche.image.urlDefault;
                            scope.affiche.image.lazy = false;
                        }
                    } else {
                        if (scope.affiche.image.url == '' && angular.isDefined(scope.affiche.image.urlDefault)) {
                            scope.affiche.image.url = scope.affiche.image.urlDefault;
                        }
                    }
                }

                if (angular.isDefined(scope.affiche.badge) && angular.isDefined(scope.affiche.badge.text)) {
                    scope.affiche.badge.text = $sce.trustAsHtml(scope.affiche.badge.text[0]);
                }


                scope.$watch('affiche', function () {
                    preTraitementImage();
                }, true);

                scope.isBookable = function () {
                    return (scope.affiche.state == STATE_ONLINE || scope.affiche.state == STATE_AVAILABLE);
                };
                scope.isClosed = function () {
                    return (scope.affiche.state == STATE_OFFLINE || scope.affiche.state == STATE_END);
                };
                scope.isCancelled = function () {
                    return (scope.affiche.state == STATE_CANCEL_REFUND || scope.affiche.state == STATE_CANCEL_NO_REFUND || scope.affiche.state == STATE_CANCEL);
                };
                scope.isDeferred = function () {
                    return (scope.affiche.state == STATE_DEFER_REFUND || scope.affiche.state == STATE_DEFER_NO_REFUND);
                };
                scope.isFull = function () {
                    return (scope.affiche.state == STATE_COMPLETE);
                };
                scope.isSoon = function () {
                    return (scope.affiche.state == STATE_SOON);
                };

                scope.showPrice = function () {
                    return (scope.isBookable() || scope.isSoon());
                };

                setTimeout(function () {
                    $(element).trigger('affichedigitick:init');
                }, 1000);
            }
        };
    }]);
}(angular, jQuery));

(function (angular, $) {
    'use strict';
    angular.module('digitickApp').directive('templateTickets', ['$sce', function ($sce) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: $sce.trustAsResourceUrl(getAsset('bundles/digitickcms/views/tickets.html'))
        };
    }]);
}(angular, jQuery));

(function (angular, $) {
    'use strict';
    angular.module('digitickApp').directive('templateDate', ['$sce', function ($sce) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                dateStart: '=dateStart',
                dateEnd: '=dateEnd',
                longFormat: '=longFormat'
            },
            templateUrl: $sce.trustAsResourceUrl(getAsset('bundles/digitickcms/views/date.html'))
        };
    }]);
}(angular, jQuery));

(function (angular, $) {
    'use strict';
    angular.module('digitickApp').directive('templatePrice', ['$sce', function ($sce) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                price: '=price'
            },
            templateUrl: $sce.trustAsResourceUrl(getAsset('bundles/digitickcms/views/price.html'))
        };
    }]);
}(angular, jQuery));

//---------------------------------------------
// FACTORIES
//---------------------------------------------
(function (angular, $) {
    'use strict';
    angular.module('digitickApp').factory('CitiesFactory', ['$http', '$q', function ($http, $q) {
        var Factory = {
            getCities: function () {
                var deferred = $q.defer();
                var url = getUrl('cms/locations');
                var config = {cache: true};
                $http.get(url, config)
                    .success(function (data) {
                        deferred.resolve(data);
                    })
                    .error(function (msg, code) {
                        deferred.reject('Impossible de récupérer la listes des villes');
                    });
                return deferred.promise;
            }
        };
        return Factory;
    }]);
}(angular, jQuery));

(function (angular, window, $) {
    'use strict';
    angular.module('digitickApp').factory('AuthService', ['$cookies', function ($cookies) {
        var Factory = {
            getUser: function () {
                Factory.user = $cookies.getObject('next-user');
            },
            user: null,
            isAuth: function () {
                if (Factory.user == null) {
                    Factory.getUser();
                }
                return (
                    angular.isDefined(Factory.user) &&
                    angular.isDefined(Factory.user.firstName) && angular.isDefined(Factory.user.lastName) &&
                    Factory.user.firstName != null && Factory.user.lastName != null
                );
            }
        };
        return Factory;
    }]);
}(angular, jQuery));

(function (angular, window, $) {
    'use strict';
    angular.module('digitickApp').factory('ShoppingCartFactory', ['$http', '$q', '$window', '$rootScope', '$cookies', function ($http, $q, $window, $rootScope, $cookies) {
        function items2itemsGroups(Factory) {
            var key;
            var itemsGroups = {};
            for (key in Factory.items) {
                var item = angular.copy(Factory.items[key]);
                if(!itemsGroups.hasOwnProperty(item.representation.id)){
                    itemsGroups[item.representation.id] = {
                        representation: item.representation,
                        tarifs: {},
                        tarifsNumber: 0,
                        price: 0,
                        insurance: '',
                        insurancePrice: 0
                    };
                }
                var idGroup = item.tarifId + '_' + item.costs;
                if(!itemsGroups[item.representation.id].tarifs.hasOwnProperty(idGroup)){
                    itemsGroups[item.representation.id].tarifs[idGroup] = [];
                    itemsGroups[item.representation.id].tarifsNumber++;
                }
                itemsGroups[item.representation.id].tarifs[idGroup].push(item);

                for (key in Factory.insurances) {
                    if(Factory.insurances[key].id == item.assurancePanierId){
                        itemsGroups[item.representation.id].insuranceId = item.assurancePanierId;
                        itemsGroups[item.representation.id].insurancePrice = Factory.insurances[key].montant;
                        break;
                    }
                }
                itemsGroups[item.representation.id].price += item.price;
            }
            return angular.copy(itemsGroups);
        }
        var Factory = {
            items: [],
            itemsGroups: {},
            total: 0,
            costs: [],
            loading: false,
            getShoppingCart: function () {
                Factory.loading = true;
                var deferred = $q.defer();
                if (angular.isUndefined($cookies.getAll()[$rootScope.sessionName])) {
                    Factory.items = [];
                    Factory.itemsGroups = {};
                    Factory.total = 0;
                    Factory.costs = [];
                    Factory.insurances = [];
                    deferred.resolve(Factory);
                    Factory.loading = false;
                    return deferred.promise;
                }
                var url = getUrl('business/shopping-cart');
                var config = {withCredentials: true};
                $http.get(url, config)
                    .success(function (data) {
                        Factory.items = angular.isDefined(data.items) ? data.items : [];
                        Factory.total = angular.isDefined(data.total) ? data.total : 0;
                        Factory.deliveryType = angular.isDefined(data.deliveryType) ? data.deliveryType : null;
                        Factory.insurances = angular.isDefined(data.insurances) ? data.insurances : [];
                        Factory.itemsGroups = items2itemsGroups(Factory);

                        deferred.resolve(Factory);
                        Factory.loading = false;
                    })
                    .error(function (msg, code) {
                        deferred.reject('Impossible de récupérer le contenu du panier');
                        Factory.loading = false;
                    });
                return deferred.promise;
            },
            getTotal: function () {
                return Factory.total;
            },
            getDeliveryType: function () {
                return Factory.deliveryType;
            },
            getDeliveryTypeLabel: function () {
                switch (Factory.deliveryType.id) {
                    case 1:
                        return 'frais de réservation';
                    case 3:
                    case 7:
                    case 56:
                    case 57:
                    case 58:
                        return "frais de réservation et d'envoi";
                }
            },
            getTotalCostsByItems: function () {
                var costs, key;
                var totalCostsByItems = 0;
                for (key in Factory.items) {
                    costs = parseFloat(Factory.items[key].costs);
                    totalCostsByItems = totalCostsByItems + costs;
                }
                return totalCostsByItems;
            },
            getItems: function () {
                return Factory.items;
            },
            getItemsGroups: function () {
                return Factory.itemsGroups;
            },
            getNbItems: function () {
                if (Factory.items == null) {
                    return null;
                }
                return Factory.items.length;
            },
            getNbItemsByTarifId: function (tarifId) {
                var nbItemsTarif = 0;
                angular.forEach(Factory.items, function (value, key) {
                    if (value.tarifId == tarifId) {
                        nbItemsTarif++;
                    }

                });
                return nbItemsTarif;
            },
            getRepresentationVisual: function (representation) {
                if(angular.isDefined(representation.evenement.vignette)){
                    return representation.evenement.vignette;
                }
            },
            validate: function () {
                window.localLinkClicked = true;
                window.location.href = getUrlLegacy('ext/digitick/index.php?p=201&langue=' + document.documentElement.lang);
            },
            clear: function (itemId) {
                Factory.loading = true;
                var deferred = $q.defer();
                var url = getUrl('business/shopping-cart/clear');
                if (angular.isDefined(itemId)) {
                    url += '/' + itemId;
                }
                var config = {withCredentials: true};
                $http.get(url, config)
                    .success(function (data) {
                        Factory.items = angular.isDefined(data.items) ? data.items : [];
                        Factory.total = angular.isDefined(data.total) ? data.total : 0;
                        Factory.deliveryType = angular.isDefined(data.deliveryType) ? data.deliveryType : null;
                        Factory.insurances = angular.isDefined(data.insurances) ? data.insurances : [];
                        Factory.itemsGroups = items2itemsGroups(Factory);

                        $("body").trigger('shopping-cart:delete', [data.billets_deleted]);
                        deferred.resolve(data);
                        Factory.loading = false;
                    })
                    .error(function (msg, code) {
                        deferred.reject('Impossible de supprimer le panier');
                        Factory.loading = false;
                    });
                return deferred.promise;
            }
        };
        return Factory;
    }]);
}(angular, window, jQuery));

//---------------------------------------------
// FILTERS
//---------------------------------------------
(function (angular, $) {
    'use strict';
    angular.module('digitickApp').filter('trim', [function () {
        return function (input) {
            return input.trim();
        };
    }]);
}(angular, jQuery));

(function (angular, $) {
    'use strict';
    angular.module('digitickApp').filter('ucfirst', [function () {
        return function (input) {
            if (angular.isString(input)) {
                return input.charAt(0).toUpperCase() + input.substring(1);
            }
            return input;
        };
    }]);
}(angular, jQuery));

(function (angular, $) {
    'use strict';
    angular.module('digitickApp').filter('ucword', [function () {
        return function (input) {
            if (angular.isString(input)) {
                return input.split(' ').map(function (ch) {
                    return ch.charAt(0).toUpperCase() + ch.substring(1);
                }).join(' ');
            }
            return input;
        };
    }]);
}(angular, jQuery));

(function (angular, $) {
    'use strict';
    angular.module('digitickApp').filter('priceFilter', [function () {
        return function (price, isCents) {
            if (angular.isUndefined(isCents)) {
                isCents = true;
            }
            if (isCents) {
                price = price / 100;
            }
            var dplaces = price == parseInt(price, 10) ? 0 : 2;
            return price.toFixed(dplaces).replace(".", ",");
        };
    }]);
}(angular, jQuery));
